<template>
    <AppLayout class="bg-yellow-50">
        <div class="flex h-screen w-screen flex-col items-center overflow-auto">
            <AppHeader />
            <AppMain />
            <AppFooter />
        </div>
    </AppLayout>
</template>
